const React = require('react');
const DownloadIcon = require('../../../../../../../../../../icons/Download');
const downloadReportDocument = require('../../../../../../../../../../../utils/downloadReportDocument');
const withState = require('../../../../../../../../../../../utils/withState');
const BtnTableGlobal = require('../BtnTableGlobal');

module.exports = withState((setState) => {
  return ({loading}, {filter, sort = {}, report, type = 'csv'}) => {
    return (
      <BtnTableGlobal
        icon={DownloadIcon}
        text={type}
        loading={loading}
        onClick={() => {
          setState({loading: true});
          downloadReportDocument(filter, sort, report, type)
              .finally(() => {
                setState({loading: false});
              });
        }}
      />
    )
  }
})
